import React from "react";
export default function Blog() {

    return (
        <>
            <title>Blog - L C Mills Consulting</title>
            <div className="container">
                <div className="body">

                </div>
            </div>
        </>
    );
}
